import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import LogoutIcon from '@material-ui/icons/PowerSettingsNew';
import AuthService from '../../auth/AuthService';
import { Home } from '@material-ui/icons';
import appConstants, { SESSION_STORAGE_KEYS } from '../../appConstants';
import { useNavigate, useLocation } from 'react-router-dom';
import PageNotFound from '.';

// Using hardcoded colors since this page should be independent of the theme
const styles = {
  button: {
    width: 180,
    marginTop: 16,
    alignSelf: 'center',
    backgroundColor: 'rgba(12, 107, 185, 1)',
    textTransform: 'none',
    height: 44,
    color: '#FFFFFF',
    fontSize: 16
  },
  icon: {
    padding: '0px 8px 0px 8px',
    fontSize: 22
  },
  homeButton: {
    marginRight: 16,
    backgroundColor: 'rgba(12, 107, 185, 1)',
  }
};

const AccessDenied = (props) => {
  const { classes } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const {customMessage, hideHomeButton = false} = location.state || {};
  
  const goToHome = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.ACTIVE_SETTINGS_MODULE);
    navigate(appConstants.NAV_URLS.HOME);
  };
  return (
    <PageNotFound
      errorLabel="Access Forbidden"
      errorDescription="It seems you tried to access a page you did not have prior authorization for."
      statusCode="403"
      customMessage={customMessage || ""}
    >
      <div>
        {!hideHomeButton && (
          <Button
            variant="contained"
            size="small"
            color="primary"
            classes={{ root: `${classes.button} ${classes.homeButton}` }}
            onClick={goToHome}>
          <Home classes={{ root: classes.icon }} />
          Home
        </Button>
        )}
        <Button
          variant="contained"
          size="small"
          color="primary"
          classes={{ root: classes.button }}
          onClick={AuthService.logout}>
          <LogoutIcon classes={{ root: classes.icon }} />
          Log Out
        </Button>
      </div>
    </PageNotFound>
  );
};

export default withStyles(styles)(AccessDenied);
